import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const pRequestSummaryReport = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.RequestService}p_request_summary_report`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
